// menu.js
export const Menu = {
    loadMode() {
        return localStorage.getItem("menuMode") || "user";
    },

    saveMode(mode) {
        localStorage.setItem("menuMode", mode);
    },

    fade() {
        document.body.classList.add("menu-fade");
        setTimeout(() => document.body.classList.remove("menu-fade"), 300);
    },

    toggle() {
        const current = this.loadMode();
        const next = current === "user" ? "admin" :
            current === "admin" ? "ultra" : "user";
        this.saveMode(next);
        this.fade();
        return next;
    }
};
